import { render, staticRenderFns } from "./Cabecalho.vue?vue&type=template&id=be45771c&scoped=true"
import script from "./Cabecalho.vue?vue&type=script&lang=js"
export * from "./Cabecalho.vue?vue&type=script&lang=js"
import style0 from "./Cabecalho.vue?vue&type=style&index=0&id=be45771c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be45771c",
  null
  
)

export default component.exports